import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SubscribeComponent } from './subscribe/subscribe.component';
import { SubscribeThankYouComponent } from './subscribe-thank-you/subscribe-thank-you.component';
import {CookiePolicyComponent} from "./cookie-policy/cookie-policy.component";
import {PrivacyPolicyComponent} from "./privacy-policy/privacy-policy.component";
import { WeddingComponent } from './wedding/wedding.component';
import { LinkHubComponent } from './link-hub/link-hub.component';
import { ServicesPageComponent } from './pages/services-page/services-page.component';
import { AboutPageComponent } from './pages/about-page/about-page.component';
import { ContactPageComponent } from './pages/contact-page/contact-page.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      titleKey: 'seo.home.title',
      descriptionKey: 'seo.home.description'
    }
  },
  {
    path: 'szolgaltatasok',
    component: ServicesPageComponent,
    data: {
      titleKey: 'seo.services.title',
      descriptionKey: 'seo.services.description'
    }
  },
  {
    path: 'rolunk',
    component: AboutPageComponent,
    data: {
      titleKey: 'seo.about.title',
      descriptionKey: 'seo.about.description'
    }
  },
  {
    path: 'kapcsolat',
    component: ContactPageComponent,
    data: {
      titleKey: 'seo.contact.title',
      descriptionKey: 'seo.contact.description'
    }
  },
  { path: 'wedding', component: WeddingComponent, data: {
    titleKey: 'seo.wedding.title',
    descriptionKey: 'seo.wedding.description'
  } },
  { path: 'links', component: LinkHubComponent },
  { path: 'subscribe', component: SubscribeComponent },
  { path: 'thanks', component: SubscribeThankYouComponent },
  { path: 'cookie-policy', component: CookiePolicyComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' } // Ha nem található az útvonal, menjen a Home-ra
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
